import * as React from "react";
import { useDispatch } from "react-redux";
import { Box, Skeleton, Stack, Typography } from "@mui/material";

import {
  setCustomModal,
  setModalTitle,
  setParticipantsCount,
  setParticipantsId,
  setParticipantsType,
  setModalType,
} from "../../../redux/features/settingSlice";
import { spaceAvatar } from "../../../utils/SpaceAvatar";
import CustomAvatar from "../CustomAvatar";
import RightLeftChecker from "../../../utils/RightLeftChecker";

const AvatarList = ({
  avatarData,
  size,
  type,
  pinAvatar,
  showProfile,
  notClick,
}) => {
  const dispatch = useDispatch();
  const participantsCount = avatarData?.participants_count;

  const handleParticipantsModal = () => {
    if (type === "table") {
      dispatch(setModalTitle(null));
    } else {
      dispatch(setModalTitle(avatarData?.title));
      // dispatch(setOwnerId(avatarData?.owner.id));
    }
    dispatch(setCustomModal(true));
    dispatch(setModalType("Participants"));
    dispatch(setParticipantsCount(avatarData?.participants_count));
  };

  const handleOpenParticipant = (e) => {
    !notClick && e.stopPropagation();

    !notClick && handleParticipantsModal();

    dispatch(setParticipantsId(avatarData?.pk));
    dispatch(setParticipantsType(type));
  };

  return (
    <>
      {!avatarData && (
        <Box sx={{ display: "flex" }}>
          {Array(3)
            .fill("")
            .map((e, i) => {
              return (
                <Skeleton
                  key={i}
                  variant='circular'
                  width={size ? size : 40}
                  height={size ? size : 40}
                  sx={{
                    mr: "8px",
                    ml: "2px",
                  }}
                />
              );
            })}
        </Box>
      )}

      {avatarData && (
        <Stack
          onClick={handleOpenParticipant}
          direction='row'
          spacing={spaceAvatar(
            avatarData.participants_count,
            type,
            showProfile
          )}
          sx={{
            display: "flex",
            alignItems: "center",
            position: "relative",
          }}
        >
          {pinAvatar && (
            <>
              <Box
                sx={{
                  height: "46px",
                  borderRight: "2px solid",
                  borderColor: "#BDBDBD",
                  position: "absolute",
                  left: "18px",
                  top: "40px",
                }}
              ></Box>
              <Box
                sx={{
                  height: "78px",
                  borderRight: "2px dashed",
                  borderColor: "#BDBDBD",
                  position: "absolute",
                  left: "22px",
                  top: "70px",
                }}
              ></Box>
              <Box sx={{ position: "absolute", top: "104px", left: "8px" }}>
                <CustomAvatar
                  // link={
                  //   "/profile/" + avatarData?.first_converse.author.username
                  // }
                  borderSize={1.5}
                  size={26}
                  src={avatarData?.first_converse.author.avatar}
                  alt={avatarData?.first_converse.author.username}
                />
              </Box>
            </>
          )}

          {avatarData?.participants
            .slice(0, participantsCount > 7 ? 6 : 7)
            .map((row, i) => {
              return (
                <Box
                  key={row.id}
                  sx={{
                    display: `${type === "table" ? "block" : "flex"}`,
                    alignItems: "center",
                    zIndex: 2,
                  }}
                >
                  <Box sx={{ mr: "10px", mt: "2px", ml: i === 0 ? "2px" : 0 }}>
                    <CustomAvatar
                      link={
                        showProfile &&
                        participantsCount < 5 &&
                        type === "table" &&
                        "/profile/" + row.username
                      }
                      borderSize={1.5}
                      size={size ? size : 40}
                      src={row.avatar}
                      alt={row.nickname}
                    />
                  </Box>

                  {/* max 4 item show name  */}
                  {/* {type === "table" && avatarData?.participants_count < 5 && (
                  <Typography
                    noWrap
                    sx={{
                      textAlign: "center",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "20px",
                      color: "secondary.main",
                      marginTop: "8px",
                      width: "64px",
                    }}
                  >
                    {row.nickname}
                  </Typography>
                )} */}
                </Box>
              );
            })}

          {participantsCount > 0 && participantsCount < 3 && !notClick && (
            <Typography
              onClick={() => handleParticipantsModal()}
              sx={{
                fontSize: size > 50 ? "16px" : "14px",
                // fontWeight: "600",
                lineHeight: "20px",
                color: "secondary.main",
                marginTop: `${size > 50 ? "20px" : "4px"} !IMPORTANT`,
                marginLeft: `${size > 50 ? "auto" : "px"} !IMPORTANT`,
                mr: "6px !IMPORTANT",
                cursor: "pointer",
                direction: RightLeftChecker(
                  avatarData?.participants[1].nickname
                )
                  ? "rtl"
                  : "ltr",
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
                textAlign: "left",
              }}
            >
              {avatarData?.participants[0].nickname} &{" "}
              {avatarData?.participants[1].nickname}
            </Typography>
          )}
          {participantsCount - 7 > 0 && (
            <Typography
              onClick={() => handleParticipantsModal()}
              sx={{
                display: "flex",
                alignItems: "center",
                fontSize: size > 50 ? "15px" : "10px",
                fontWeight: "600",
                lineHeight: "20px",
                color: "secondary.main",
                marginTop: `${size > 50 ? "20px" : "4px"} !IMPORTANT`,
                marginLeft: `${size > 50 ? "auto" : "6px"} !IMPORTANT`,
                mr: "6px !IMPORTANT",
                cursor: "pointer",
                height: "100%",
              }}
            >
              + {participantsCount - 6} More
            </Typography>
          )}
        </Stack>
      )}
    </>
  );
};
export default AvatarList;
